// extracted by mini-css-extract-plugin
export var messageSideLeft = "_t1-1";
export var stateContainer = "_t1-0";